// components/ForceUpdateScreen.js
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import SystemUpdateAltRoundedIcon from '@mui/icons-material/SystemUpdateAltRounded';
import schoonerLogo from '../assets/schoonerlogo.png';

export default function ForceUpdateScreen({ storeUrl }) {
  const openStore = () => {
    if (storeUrl) window.open(storeUrl, '_blank', 'noopener');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        overflow: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(circle at 50% -10%, rgba(47, 145, 207, 0.18) 0, transparent 42%), #F3F7FA',
        px: 2.5,
        pt: 'max(24px, env(safe-area-inset-top))',
        pb: 'max(24px, env(safe-area-inset-bottom))',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 390,
          borderRadius: '28px',
          background: '#FFFFFF',
          border: '1px solid #DCE7EF',
          boxShadow: '0 24px 70px rgba(22, 62, 91, 0.14)',
          px: { xs: 3, sm: 4 },
          py: { xs: 3.5, sm: 4.5 },
          textAlign: 'center',
        }}
      >
        <Box
          component="img"
          src={schoonerLogo}
          alt="Schooner Punch Clock"
          sx={{
            width: 70,
            height: 70,
            borderRadius: '20px',
            display: 'block',
            mx: 'auto',
            mb: 2,
            boxShadow: '0 10px 28px rgba(20, 117, 181, 0.18)',
          }}
        />

        <Typography sx={{ color: '#46708F', fontSize: '0.72rem', fontWeight: 900, letterSpacing: '0.13em', mb: 1.5 }}>
          SCHOONER PUNCH CLOCK
        </Typography>

        <Typography
          component="h1"
          sx={{
            color: '#0b1f33',
            fontSize: { xs: '1.65rem', sm: '1.8rem' },
            fontWeight: 850,
            letterSpacing: '-0.035em',
            lineHeight: 1.12,
            mb: 1.25,
          }}
        >
          A quick app update
        </Typography>

        <Typography
          sx={{
            color: '#5E7182',
            fontSize: '0.96rem',
            lineHeight: 1.5,
            mb: 3.25,
          }}
        >
          This update improves performance and fixes important issues.
        </Typography>

        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={openStore}
          startIcon={<SystemUpdateAltRoundedIcon />}
          sx={{
            minHeight: 54,
            borderRadius: '14px',
            fontSize: '1rem',
            fontWeight: 800,
            textTransform: 'none',
            background: '#1268A8',
            boxShadow: '0 10px 24px rgba(18, 104, 168, 0.24)',
            '&:hover': {
              background: '#0E5B94',
              boxShadow: '0 12px 28px rgba(18, 104, 168, 0.3)',
            },
          }}
        >
          Update App
        </Button>

      </Box>
    </Box>
  );
}
